// Dependencies
import mediaQueries from './media-queries';

// Exports
// -------

export default function _matchViewport(value) {
  if (!value) {
    console.warn('matchViewport: No value provided');
    return false;
  }

  var mediaQuery = mediaQueries[value];

  if (!mediaQuery) {
    console.warn('matchViewport: Unknown media query');
    return false;
  }

  if (window.matchMedia && window.matchMedia('only all').matches) {
    return window.matchMedia(mediaQuery.query).matches ? true : false;
  } else {
    return true;
  }
}



/** WEBPACK FOOTER **
 ** ./~/vt-frontend-engine/app/scripts/principles/responsive/match-viewport.js
 **/